import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Nav from './Nav';
import SearchEngine from "./SearchEngine";
import { useState } from "react";

const Header = () => {
  const [searchEngineVisible, setSearchEngineVisible] = useState(false);

const headerData = useStaticQuery(graphql`
  query nav {
    headerNav: datoCmsHeaderNav {
      navItems {
        navLinks {
          typeOfLink
          linkUrl
          linkLabel
          isThisAButton
          dropdownLinks {
            linkUrl
            label
            isThisAButton
          }
        }
      }
      headerLogo {
        url
      }
    }
  }
`); 

const path = typeof window !== "undefined" && window.location.pathname;
const navData = headerData.headerNav;

  return (
    <header  data-datocms-noindex className={`${path === '/' && 'home-header'}`}>
      {
        typeof window !== 'undefined' && <SearchEngine searchEngineVisible={searchEngineVisible} setSearchEngineVisible={setSearchEngineVisible} />
      }
      <Nav navData={navData} path={path} setSearchEngineVisible={setSearchEngineVisible}/>
    </header>
  )
}

export default Header
